import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Input,
  Card,
  CardBody,
} from 'reactstrap';
import * as commonActions from '@common/common.action';
import { DataTable, Column } from 'vivace-fluent-motion';
import { useDispatch } from 'react-redux';
import DescarteApi from '../../descarte.api';
import CommonFunctions from '@util/functions.common';
import IntlMessage from "../../../../helpers/intlMessage";

export default function ModalDetalhesLote(props) {
  const [modalAberto, setModalAberto] = useState(false);
  const [listaDetalhes, setListaDetalhes] = useState([]);
  const [listaDraf, setListaDraft] = useState([]);
  const [selectGrid, setSelectGrid] = useState(0);
  const [pesquisa, setPesquisa] = useState('');
  const backdrop = !props.backdrop ? false : props.backdrop;
  const keyboard = props.keyboard === undefined ? true : props.keyboard;

  const dispatch = useDispatch();

  function resetInputs() {
    setPesquisa('');
    setListaDetalhes([]);
    setListaDraft([]);
  }

  function toggle() {
    setModalAberto(!modalAberto);
    dispatch(commonActions.showModal(!modalAberto));
    props.onModal(!modalAberto);
  }

  function toggleCheckBox(checked) {
    let checkboxes = document.getElementsByClassName('descartetable-modal-detalhes')[0].getElementsByClassName('checkbox');
    for (let i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i] !== checked) {
        checkboxes[i].checked = checked;
        let doc = document.getElementsByClassName('descartetable-modal-detalhes')[0].getElementsByTagName('tr')[i + 1];
        if (checked) {
          setSelectGrid(checkboxes.length);
          doc && doc.setAttribute('datacheck', 'true');
        } else {
          setSelectGrid(0);
          doc && doc.setAttribute('datacheck', 'false');
        }
      }
    }
  }

  function restaurarItens() {
    let items = [];

    let checkboxes = document.getElementsByClassName('descartetable-modal-detalhes')[0].querySelectorAll('input[name=checkbox]:checked');
    for (let i = 0; i < checkboxes.length; i++) {
      // eslint-disable-next-line array-callback-return
      listaDetalhes.find((l) => {
        if (l.itemId === Number(checkboxes[i].id)) {
          items.push({ itemId: l.itemId });
        }
      });
    }

    dispatch(commonActions.showFadeCarregando(true));
    DescarteApi.restaurarItemsDescartados(props.id, items).then(() => {
      setModalAberto(!modalAberto);
      props.onModal(!modalAberto);
      props.confirmar();
      dispatch(commonActions.showFadeCarregando(false));
    });
  }

  useEffect(() => {
    if (pesquisa && listaDetalhes.length > 0) {
      let draft = listaDetalhes;
      let listaFiltrada = [];
      draft.forEach(el => {
        if (el.exame.indexOf(pesquisa.toUpperCase()) >= 0) {
          listaFiltrada.push(el);
        }
        return listaFiltrada;
      });
      setListaDraft(listaFiltrada);
    }
  }, [pesquisa]);

  useEffect(() => {
    if (props.showModalDescarte) {
      DescarteApi.getItemsDescartados(props.id)
        .then((res) => {
          insertSelect(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [props.showModalDescarte]);

  useEffect(() => {
    resetInputs();
    setModalAberto(props.showModalDescarte);
    dispatch(commonActions.showModal(props.showModalDescarte));
  }, [props.showModalDescarte]);

  function selectItem(e) {
    let tr = document.getElementsByTagName('tr');
    let checkboxes = document.getElementsByClassName('descartetable-modal-detalhes')[0].querySelectorAll('input[name=checkbox]:checked');
    setSelectGrid(checkboxes.length);
    let items = document.getElementsByClassName('descartetable-modal-detalhes')[0].getElementsByTagName('tr').length;
    if (checkboxes.length < items - 1) {
      document.getElementById('selectMaterias').checked = false;
    } else {
      document.getElementById('selectMaterias').checked = true;
    }
    for (let i = 0; i < tr.length - 1; i++) {
      if (
        document.getElementsByTagName('tr')[i + 1].getElementsByTagName('td').length > 0 &&
        document.getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0].getElementsByTagName('input')[0]
      ) {
        if (
          document.getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0].getElementsByTagName('input')[1].id === e.target.id
        ) {
          if (
            document.getElementsByTagName('tr')[i + 1].getAttribute('datacheck') === 'true'
          ) {
            document.getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'false');
          } else {
            document.getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'true');
          }
        }
      }
    }
  }

  function insertSelect(dados) {
    const novaLista = [];
    dados.map((item) => {
      return novaLista.push({
        idLote: item.idLote,
        itemId: item.itemId,
        material: item.material,
        exame: item.exame,
        pedido: item.pedido,
        paciente: item.paciente,
        dataPedido: item.dataPedido && CommonFunctions.formatData(item.dataPedido),
        idFrasco: item.idFrasco,
        numeroControle: item.numeroControle,
        peso: item.peso,
        select: (
          <input
            className="checkbox"
            name="checkbox"
            type="checkbox"
            id={item.itemId}
            onClick={(e) => selectItem(e)}
          />
        ),
      });
    });

    setListaDetalhes(novaLista);
  }

  function onChangeSelect(e) {
    let tr = document.getElementsByTagName('tr');
    for (let i = 0; i < tr.length - 1; i++) {
      if (
        document.getElementsByTagName('tr')[i + 1].getElementsByTagName('td')
          .length > 0 &&
        document
          .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
          .getElementsByTagName('input')[0]
      ) {
        if (
          document
            .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
            .getElementsByTagName('input')[1].id === e.data.itemId.toString()
        ) {
          if (
            document
              .getElementsByTagName('tr')[i + 1].getAttribute('datacheck') === 'true'
          ) {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'false');
            document.getElementById(e.data.itemId.toString()).checked = false;
          } else {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'true');
            document.getElementById(e.data.itemId.toString()).checked = true;
          }
        }
      }
    }
    let checkboxes = document.getElementsByClassName('descartetable-modal-detalhes')[0].querySelectorAll('input[name=checkbox]:checked');
    setSelectGrid(checkboxes.length);
    let items = document.getElementsByClassName('descartetable-modal-detalhes')[0].getElementsByTagName('tr').length;
    if (checkboxes.length < items - 1) {
      document.getElementById('selectMaterias').checked = false;
    } else {
      document.getElementById('selectMaterias').checked = true;
    }
  }

  return (
    <React.Fragment>
      <Modal
        className="mv-materiaisdescartados-modal-detalhes"
        backdrop={backdrop}
        keyboard={keyboard}
        centered
        isOpen={modalAberto}
        toggle={toggle}
      >
        <ModalHeader toggle={!props.close ? toggle : props.close}>
          Lista de Materiais do lote {props.tipo} para restauração
          {/* de sepultamento | especial */}
        </ModalHeader>
        <ModalBody>
          <Card>
            <CardBody>
              <Row>
                <div className="col-12">
                  <div
                    className="label-data col-auto"
                    style={{ float: 'left' }}
                  >
                    Nr Exame:
                  </div>
                  <Input
                    onChange={(e) => setPesquisa(e.target.value)}
                    className="col-3"
                    value={pesquisa}
                    placeholder="Digite o Nr. Exame"
                  />
                </div>
              </Row>
              <br />
              <DataTable
                className="descartetable-modal-detalhes"
                onContextMenu={e => onChangeSelect(e)}
                value={pesquisa ? listaDraf : listaDetalhes}
                //pageLinkSize={20}
                responsive={true}
                selectionMode="single"
                style={{ height: '100%' }}
                columnResizeMode="expand"
                scrollable={true}
                //scrollHeight="50vh"
                scrollWidth="100%"
                //resizableColumns={listaDetalhes.length >= 1}
                //reorderableColumns={listaDetalhes.length >= 1}
                //rowsPerPageOptions={[10, 20, 50]}
                //rows={totalItensPage}
                lazy={true}
                paginator={false}
                //loading={carregando}
                //loadingIcon="mv-basico-menu_secundario"
                emptyMessage={<IntlMessage id="dashboards.reports.noResultsFound" />}
                alwaysShowPaginator={false}
                autoLayout={true}
              //footer={<RenderizarFooter total={totalItens} />}
              >
                <Column
                  sortable={false}
                  field="select"
                  style={{ width: '25px' }}
                  header={
                    listaDetalhes.length >= 1 && (
                      <input
                        type="checkbox"
                        id="selectMaterias"
                        name="selectMaterias"
                        onChange={(e) => {
                          toggleCheckBox(e.target.checked);
                        }}
                      />
                    )
                  }
                />

                <Column
                  sortable={false}
                  field="exame"
                  style={{ width: '150px' }}
                  header="Exame"
                />

                <Column
                  sortable={false}
                  field="idFrasco"
                  style={{ width: '250px' }}
                  header="Frasco"
                />

                <Column
                  sortable={false}
                  field="pedido"
                  style={{ width: '150px' }}
                  header="Pedido"
                />

                {/* { <Column
                        sortable={false}
                        field='tipo'
                        style={{ width: '150px' }}
                        header='Tipo do Descate'
                      /> } */}
                <Column
                  sortable={false}
                  field="paciente"
                  style={{ width: '250px' }}
                  header="Paciente"
                />
                <Column
                  sortable={false}
                  field="peso"
                  style={{ width: '150px' }}
                  header="Peso (g)"
                />
                <Column
                  sortable={false}
                  field="material"
                  style={{ width: '250px' }}
                  header="Material"
                />

                <Column
                  sortable={false}
                  field="dataPedido"
                  style={{ width: '250px' }}
                  header="Data do Pedido"
                />

                <Column
                  sortable={false}
                  field="numeroControle"
                  style={{ width: '250px' }}
                  header="Numero Lote"
                />
              </DataTable>
            </CardBody>
          </Card>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={!props.cancelar ? toggle : props.cancelar}
            className={`button-cancel`}
            color="secondary"
          >
            <IntlMessage id="dashboards.examDetails.cancel" />
          </Button>
          <Button
            className={`button-confirm`}
            onClick={() => restaurarItens()}
            disabled={!selectGrid}
            color="primary"
          >
            Restaurar
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/pages/descarte/modais/detalhes/index.js